export default "__VITE_ASSET__D$QFfjdD__"